import {ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from "@angular/core";
import {UserService} from "../shared/user.service";
import {User} from "./user.model";
declare let $:any;

@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'admin-app-users',
  styles: [ require('./users.component.css') ],
  template: require('./users.component.html')
})
export class UsersComponent implements OnInit {

  users: User[];
  currentUser: User;

  @ViewChild("userModalDiv") userModalDiv: ElementRef;

  constructor(private userService: UserService){}

  ngOnInit(): void {
    this.getUsers();
  }

  getUsers(){
    this.userService.getUsers()
      .subscribe(users => this.users = users);
  }

  onSelect(user: User){
    this.userService.getUserById(user['_id'])
      .subscribe(user => {
        this.currentUser = user;
        this.openModal();
      });
  }

  openCreateUserModal(){
    this.currentUser = {
      username: "",
      password: "",
      name: ""
    };
    this.openModal();
  }
  //open modal dialog
  openModal(){
    $(this.userModalDiv.nativeElement).modal('show');
  }

  //close modal dialog
  closeModal(){
    $(this.userModalDiv.nativeElement).modal('hide');
  }

  createUser(){
    this.userService.createUser(this.currentUser)
      .subscribe(res => {
        this.getUsers();
        this.closeModal();
      });
  }

  updateUser(){
    this.userService.updateUser(this.currentUser)
      .subscribe(res => {
        this.getUsers();
        this.closeModal();
      });
  }

  save(){
    if(this.currentUser["_id"]){
      this.updateUser();
    } else {
      this.createUser();
    }
  }

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/+admin-app/+users/users.component.ts